import ResponsiveImage from '@/components/responsive-image';

export default function Album({ album }) {
    const {
        title,
        release_year,
        cover
    } = album;

    return (
        <div className="flex flex-1 flex-col overflow-hidden animate-in duration-150 fade-in-0 zoom-in-95 slide-in-from-bottom-2 min-w-20">
            <div className='animate-in-out duration-150 hover:p-1 hover:cursor-pointer'>
                {cover != null && <ResponsiveImage
                    className="rounded-sm border shadow-lg"
                    srcSet={cover.srcset}
                    height={cover.width}
                    width={cover.height}
                    alt={`${title} Album Cover`}
                />}
            </div>
            <div className="flex flex-grow flex-col py-2">
                <div className="flex-1">
                    <div className="text-lg">
                        <p className='font-bold '>{title}</p>
                        <p>({release_year})</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
